'use strict';

var React = require('react'),
    { PropTypes } = React,
    FormLink = require('../utils/FormLink'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var FormMessage = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    formLink: PropTypes.instanceOf(FormLink).isRequired
  },

  render() {
    var message = this.props.formLink.fieldMessage;

    return message && <div className='FormMessage'>{message}</div> || null;
  }
});

module.exports = FormMessage;


/** WEBPACK FOOTER **
 ** ./modals/FormMessage.jsx
 **/